import { Skeleton } from '@/shared/components';
import { cn } from '@/shared/utils';

const TAB_WIDTHS = [
  'w-[4.8rem]',
  'w-[16.9rem]',
  'w-[11.1rem]',
  'w-[8.4rem]',
  'w-[7.6rem]',
];

const ACTION_WIDTHS = ['w-[12.4rem]', 'w-[16.3rem]'];

const HistoryFilterSkeleton = () => (
  <>
    <div className="flex min-w-0 gap-[0.2rem] overflow-hidden tablet:flex-1">
      {TAB_WIDTHS.map(width => (
        <Skeleton
          key={width}
          className={cn('h-[2.8rem] shrink-0 rounded-[0.8rem]', width)}
        />
      ))}
    </div>

    <div className="flex shrink-0 gap-[1.6rem]">
      {ACTION_WIDTHS.map(width => (
        <Skeleton
          key={width}
          className={cn('h-[3.2rem] shrink-0 rounded-[1rem]', width)}
        />
      ))}
    </div>
  </>
);

export { HistoryFilterSkeleton };
